<!--
Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
Unauthorized use, copying, distribution, displaying, or public performance
of this file, via any medium, is strictly prohibited. All information
contained herein is proprietary and confidential and may not be shared
with any third party without the express written consent of Reciprocity, Inc.
-->

<template>
  <table class="table">
    <thead>
      <tr>
        <th>Question</th>
        <th>Answer</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="question in visibleQuestions" :key="question.id" :class="{ invalid: !question.isValid }">
        <td class="question">{{ question.title }}</td>
        <td class="answer">
          <i v-if="!question.isValid" class="fa fa-exclamation-circle" />
          <!-- eslint-disable-next-line vue/no-v-html -->
          <span class="answer-value" v-html="getTextValue(question)" />
          <i class="edit fa fa-pencil" title="Edit answer" @click="handleBackClick(question)" />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { VBPopover } from 'bootstrap-vue';
import { includes, sortBy } from 'lodash';

import { isVisible, validate } from './helpers';

const BLANK = '<em>No data provided</em>';

export default {
  name: 'SurveySummary',
  directives: {
    VBPopover,
  },
  props: {
    questions: {
      type: Array,
      default: null,
    },
    questionsMap: {
      type: Object,
      default: null,
    },
    optionsMap: {
      type: Object,
      default: null,
    },
  },
  computed: {
    visibleQuestions() {
      const filtered = this.questions.filter(
        question =>
          isVisible(question, this.questionsMap, this.optionsMap) && !includes(['additional_text'], question.type)
      );

      const sorted = sortBy(filtered, ['page_number', 'rank']);

      const validated = sorted.map(question => ({
        ...question,
        isValid: validate({
          type: question.type,
          required: question.required,
          text: question.text,
          options: question.options,
        }),
      }));

      return validated;
    },
  },
  methods: {
    getTextValue(question) {
      if (includes(['checkboxes', 'radio'], question.type)) {
        return (
          question.options
            .filter(option => option.picked)
            .map(option => option.title)
            .join(', ') || BLANK
        );
      } else if (question.text) {
        return question.text;
      }
      return BLANK;
    },
    handleBackClick(question) {
      this.$emit('goToQuestion', question);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/design/colors';
@import '~@/design/variables';

.table {
  table-layout: fixed;
  th {
    width: 50%;
  }

  td {
    border-width: 1px;
    position: relative;
    word-break: break-all;
  }
}

.answer-value ::v-deep p {
  margin-bottom: 0;
}

.invalid {
  /* stylelint-disable-next-line selector-max-type */
  + tr > td {
    border-top-color: $color-error;
  }
  .answer {
    color: $color-error;
  }
}

.edit {
  display: none;
  position: absolute;
  top: 3px;
  right: 0;
  padding: 10px;
  background: $color-white;
  cursor: pointer;
  color: $color-app-primary;

  tr:hover & {
    display: block;
  }
}

.fa-exclamation-circle {
  margin-right: 5px;
}
</style>
